<template>
  <div class="p-6 loading-table" v-if="loading">
    <spinner-color />
  </div>
  <div v-else>
    <data-table-order :data="this.$store.state.dataList.orders" :header="header" :body="body" :pageName="pageName"
      :titlePage="titlePage" :statusForAdvancedSearch="statusForAdvancedSearch"
      :advancedSearchData="advancedSearchData" />
  </div>
</template>

<script>
import DataTableOrder from "../components/table-components/DataTableOrder.vue";
import SpinnerColor from "@/views/components/table-components/SpinnerColor2.vue";
import loadingTable from "@/mixins/loadingTable.js";
import allStatus from "@/views/status/orderStatus";

export default {
  mixins: [loadingTable],
  components: {
    DataTableOrder,
    SpinnerColor,
  },
  data() {
    return {
      header: [
        { header: "dateOfRegistration", key: "created_at" },
        { header: "code", key: "code" },
        { header: "sender", key: "second_client" },
        { header: "receiver", key: "receiver" },
        { header: "government", key: "gov_name" },
        { header: "area", key: "area" },
        { header: "collectedAmount", key: "amount" },
        { header: "actions", key: "actions" },
      ],
      body: [
        "created_at",
        "code",
        "second_client",
        "receiver",
        "gov_name",
        "area",
        "amount",
      ],
      advancedSearchData: [
        {
          label: "dateOfRegistration",
          nameToEndpoint: "dateOfRegistration",
          max: "",
          type: "date",
        },
        { label: "code", nameToEndpoint: "code", max: "", type: "text" },
        { label: "sender", nameToEndpoint: "sender", max: 15, type: "text" },
        {
          label: "receiver",
          nameToEndpoint: "receiver",
          max: 15,
          type: "text",
        },
        { label: "area", nameToEndpoint: "area", max: 13, type: "text" },
        {
          label: "collectedAmount",
          nameToEndpoint: "collectedAmount",
          max: 15,
          type: "text",
        },
      ],
      statusForAdvancedSearch: allStatus.pickedUp,
      pageName: "order/picked-up", // New endpoint needed or use "order/with-captain" with filter? Let's assume new or reuse logic
      titlePage: "statusPickedUp", // Translation key needed
    };
  },
  async created() {
    // We might need to adjust backend to handle this pageName or filter by status 31
    // For now assuming we can pass status directly or create a new endpoint
    this.credentials.page = "order/picked-up";
    this.fetchData(this.credentials);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_loadingTable.scss";
</style>
